import React from "react";
import { Box, Typography } from "@material-ui/core";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import { formatNota } from "../../utils/formato";

const GraficaResumen = ({ datos, height = 220 }) => {
  const data = (datos || [])
    .slice()
    .sort((a, b) => {
      const yearA = Number(a.anio);
      const yearB = Number(b.anio);
      if (yearA !== yearB) return yearA - yearB;
      return Number(a.semestre) - Number(b.semestre);
    })
    .map((item) => ({
      periodo: `${item.anio}-${item.semestre}`,
      promedio: Number(item.promedio_total || 0),
      programa: item.programa,
    }));

  return (
    <Box bgcolor="#ffffff" borderRadius={12} boxShadow="0 1px 8px rgba(0, 0, 0, 0.08)" p={1.25}>
      <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 800, color: "#0f172a", lineHeight: 1.35 }}>
        Promedio total vs período
      </Typography>
      <Typography variant="caption" color="textSecondary" display="block" style={{ marginBottom: 6, fontSize: 11, lineHeight: 1.45 }}>
        Evolución del promedio total del programa seleccionado por año-semestre (eje X). Escala 0–5 alineada con las rúbricas de
        competencias.
      </Typography>
      <Box borderRadius={10} style={{ padding: "6px 0 4px" }}>
        <ResponsiveContainer width="100%" height={height}>
          <LineChart data={data} margin={{ top: 6, right: 8, left: 2, bottom: 2 }}>
            <XAxis
              dataKey="periodo"
              tick={{ fill: "#475569", fontSize: 11, fontWeight: 600 }}
              axisLine={{ stroke: "#cbd5e1" }}
              tickLine={{ stroke: "#cbd5e1" }}
            />
            <YAxis
              domain={[0, 5]}
              ticks={[0, 1, 2, 3, 4, 5]}
              tick={{ fill: "#475569", fontSize: 11, fontWeight: 600 }}
              axisLine={{ stroke: "#cbd5e1" }}
              tickLine={{ stroke: "#cbd5e1" }}
              width={34}
            />
            <Tooltip
              formatter={(value) => formatNota(value)}
              labelFormatter={(label) => `Período ${label}`}
              contentStyle={{
                backgroundColor: "#ffffff",
                border: "none",
                borderRadius: 8,
                color: "#0f172a",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
              labelStyle={{ color: "#64748b", fontWeight: 700 }}
              itemStyle={{ color: "#0f172a", fontWeight: 600 }}
            />
            {data.length > 0 && (
              <Line
                dataKey="promedio"
                name="Promedio"
                stroke="#1976d2"
                strokeWidth={2.4}
                dot={{ r: 4.5, fill: "#1976d2", stroke: "#fff", strokeWidth: 1 }}
                activeDot={{ r: 6 }}
              />
            )}
          </LineChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};

export default GraficaResumen;
